import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  day: 'Viernes',
  title: 'Preparación',
  description: 'Preparas el entorno y el "Kit de Emergencia" siguiendo nuestra lista.'
}, {
  day: 'Sábado y Domingo',
  title: 'Acción',
  description: 'Aplicas el protocolo de Conexión Sensorial paso a paso.'
}, {
  day: 'Lunes',
  title: 'Libertad',
  description: 'Tu hijo despierta con una nueva autonomía y tú con total libertad.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white" data-id="element-120">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-bold text-slate mb-4" data-id="element-123">
            Cómo funciona el fin de semana
          </h2>
          <p className="text-lg text-slate-light" data-id="element-124">
            Un plan claro, sin adivinanzas.
          </p>
        </div>

        <div className="relative" data-id="element-125">
          {/* Vertical line for desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-teal/20 -translate-x-1/2" data-id="element-126"></div>

          <div className="space-y-12 relative" data-id="element-127">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-128">
                <div className="flex-1 w-full md:text-right" data-id="element-129">
                  {index % 2 === 0 ? <div className="hidden md:block" data-id="element-130"></div> : <div className="bg-cream p-6 rounded-2xl md:text-right" data-id="element-131">
                      <h4 className="text-xl font-bold text-slate mb-2" data-id="element-132">
                        {step.title}
                      </h4>
                      <p className="text-slate-light" data-id="element-133">{step.description}</p>
                    </div>}
                </div>

                <div className="flex-shrink-0 w-24 h-24 rounded-full bg-teal text-white flex flex-col items-center justify-center shadow-lg relative z-10 border-4 border-white" data-id="element-134">
                  <span className="text-sm font-medium opacity-80 uppercase tracking-wider" data-id="element-135">
                    {step.day.split(' ')[0]}
                  </span>
                  <span className="text-2xl font-bold" data-id="element-136">{index + 1}</span>
                </div>

                <div className="flex-1 w-full" data-id="element-137">
                  {index % 2 === 0 ? <div className="bg-cream p-6 rounded-2xl text-center md:text-left" data-id="element-138">
                      <h4 className="text-xl font-bold text-slate mb-2" data-id="element-139">
                        {step.title}
                      </h4>
                      <p className="text-slate-light" data-id="element-140">{step.description}</p>
                    </div> : <div className="hidden md:block" data-id="element-141"></div>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}